import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPolygonGeometry,
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface ErosionArea extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;

    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export const erosionAreaSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),

    geometry: polygonGeometrySchema,
    pole: pointGeometrySchema,
});

export const mockErosionArea = ({
    id = 'f774f7c5-6569-457b-99df-784c14f70a9e',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Erosion Area Name',

    geometry = mockPolygonGeometry(),
    pole = mockPointGeometry(),
}: Partial<ErosionArea> = {}): ErosionArea => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,

    geometry,
    pole,
});
